function importAll(r) {
    return r.keys().map((file) => r(file));
}

export const designsImages = importAll(
    require.context("../images/design-ads/designs", false, /\.(png|jpe?g|jpg|webp)$/)
);

export const developmentsImages = importAll(
    require.context("../images/design-ads/developments", false, /\.(png|jpe?g|jpg|webp)$/)
);

export const promotionsImages = importAll(
    require.context("../images/design-ads/promotions", false, /\.(png|jpe?g|jpg|webp)$/)
);
